<template functional>
  <RouterLink
    :to="{ name: 'Home' }"
    class="fixed top-0 left-0 text-white cursor-pointer mt-10 ml-15 laptop:mt-15 laptop:ml-20"
  >
    <IconFA
      :icon="['far', 'arrow-alt-circle-left']"
      class="text-3xl text-primary cursor-pointer bg-white border-2 border-white rounded-full shadow-md"
    />
  </RouterLink>
</template>


<script>
export default {};
</script>
